<div [style.background]="item.customField8">

    <div fxLayout="column" fxLayoutGap="30px" class=" main-container" >
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px" [style.height]="item.height"  fxLayoutAlign="space-between center"
        class="sticky-row">
            <!-- Left Section -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div  [style.color]="datas[0].customField10" style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[0].customField1"></h2>
                </div>
    
            </div>
    
            <!-- Center Image -->
            <div fxFlex="33" fxFlex.xs="100" class="section-image">
                <img [src]="serverPath+datas[0].img" alt="Sale" />
            </div>
    
            <!-- Right Section -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[0].customField15" style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[0].customField14"></h2>
                </div>
            </div>
        </div>
    
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px" [style.height]="item.height" fxLayoutAlign="space-between center"
        class="sticky-row" >
            <!-- Left Section -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[1].customField10" style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[1].customField1"></h2>
                </div>
    
            </div>
    
            <!-- Center Image -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[1].customField15"  style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[1].customField14"></h2>
                </div>
            </div>
    
    
            <!-- Right Section -->
            <div fxFlex="33" fxFlex.xs="100" class="section-image">
                <img [src]="serverPath+datas[1].img" alt="Sale" />
            </div>
        </div>
    
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px" [style.height]="item.height" fxLayoutAlign="space-between center"
        class="sticky-row">
            <!-- Left Section -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[2].customField10" style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[2].customField1"></h2>
                </div>
    
            </div>
    
            <!-- Center Image -->
            <div fxFlex="33" fxFlex.xs="100" class="section-image">
                <img [src]="serverPath+datas[2].img" alt="Sale" />
            </div>
    
    
            <!-- Right Section -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[2].customField15" style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[2].customField14"></h2>
                </div>
            </div>
    
        </div>
    
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px" [style.height]="item.height" fxLayoutAlign="space-between center"
        class="sticky-row" >
            <!-- Left Section -->
            <div fxFlex="33" fxFlex.xs="100" class="section-image">
                    <img [src]="serverPath+datas[3].img" alt="Sale" />
            </div>
    
            <!-- Center Image -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[3].customField10" style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[3].customField1"></h2>
                </div>
    
            </div>
    
            <!-- Right Section -->
            <div fxFlex="33" fxFlex.xs="100" [style.background]="item.customField7" class="section-box">
                <div [style.color]="datas[3].customField15"  style="height: 100%; padding: 20px;">
                    <h2 class="title" [innerHTML]="datas[3].customField14"></h2>
                </div>
            </div>
        </div>
    
    
    </div>
</div>
